import { Box, Container, CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { I18nextProvider } from 'react-i18next';

import { createMuiTheme } from '~/assets/muiTheme/muiTheme';
import { AuthModal } from '~/base/ui/AuthModal';
import { i18n } from '~/modules/lang/LangAdapter';
import { LangTypeEnum } from '~/modules/lang/types/Lang';

import MFSurveyForm from '../apps/MFSurveyForm';

export const ReactWrapper = () => {
  // Имитация обертки родительского проекта
  return (
    <I18nextProvider i18n={i18n}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={createMuiTheme()}>
          <CssBaseline />

          <Container maxWidth="xl">
            <Box py={{ xs: 2, sm: 3 }}>
              {/*
              В этом месте рендерим нужный модуль MF для локального запуска и разработки
              с необходимыми данными имитирую рендер на родительском проекте
            */}
              <MFSurveyForm
                // Base
                apiUrl={import.meta.env.VITE_APP_API_URL}
                tokens={null}
                onLogout={() => console.log('onLogout')}
                lang={LangTypeEnum.RU}
              />

              {/* Для разработки в dev mode */}
              <AuthModal />
            </Box>
          </Container>
        </ThemeProvider>
      </StyledEngineProvider>
    </I18nextProvider>
  );
};
